import React from "react"

import {EMPTY_ARRAY} from "./index.ts"
import {getLSItem, setLSItem, useLSValue} from "./localStorage"

export enum EFeature {
  SHOW_SALESPERSON_RATINGS = "SHOW_SALESPERSON_RATINGS",
  GTM_EVENT_TOASTS = "GTM_EVENT_TOASTS",
}

export const useEnabledFeatures = (): readonly EFeature[] => {
  return useLSValue("features") ?? EMPTY_ARRAY
}

export const getEnabledFeatures = (): readonly EFeature[] => {
  return getLSItem("features")?.data ?? EMPTY_ARRAY
}

export const useIsFeatureEnabled = (...features: EFeature[]): boolean => {
  const enabledFeatures = useEnabledFeatures()

  return React.useMemo(() => {
    return features.every(feature => enabledFeatures.includes(feature))
  }, [enabledFeatures, features])
}

export const isFeatureEnabled = (...features: EFeature[]): boolean => {
  const enabledFeatures = getEnabledFeatures()

  return features.every(feature => enabledFeatures.includes(feature))
}

// Initialize LS
if (!getLSItem("features")) {
  setLSItem("features", [])
}
